import { parse } from "wellknown";
import { MapElementType } from "@/utils/constant/settings_constantes";
import DynamicMapElement from "@/utils/map/Map_DynamicElement";
import StaticElement from "@/utils/map/Map_StaticElement";
import MediaElement from "@/utils/map/Map_MediaElement";

export default class Map_Element {
  app;
  viewer;
  app;
  datasource;
  dynamicmapelements;
  staticmapelements;
  mediamapelements;

  constructor(viewer, app) {
    this.viewer = viewer;
    this.app = app;
    this.datasource;
    this.init();
  }

  init() {
    this.datasource = new Cesium.CustomDataSource("MapElements");
    this.viewer.dataSources.add(this.datasource);
    this.dynamicmapelements = new DynamicMapElement(this.viewer, this.app);
    this.staticmapelements = new StaticElement(this.viewer);
    this.mediamapelements = new MediaElement(this.viewer);
  }

  get(mapElement) {
    let elements = [];
    this.datasource.entities.values.forEach((entity) => {
      if (entity.mapElement && entity.mapElement.mae_id == mapElement.mae_id) {
        elements.push(entity);
      }
    });
    return elements;
  }

  remove(entity) {
    this.datasource.entities.remove(entity);
  }

  scanAware(awareElements) {
    let names = this.staticmapelements.getAllName();
    awareElements.forEach((awareElement) => {
      awareElement.callsign = decodeURIComponent(awareElement.callsign);
      this.addAwareElement(awareElement);
      const id = names.indexOf(awareElement.callsign);
      if (id != -1) {
        names = names.slice(id, 1);
      }
    });
    names.forEach((name) => {
      this.staticmapelements.removeByName(name);
    });
  }

  scanElements(mapElements) {
    let ids = this.dynamicmapelements.getAllId();

    mapElements.forEach((mapElement) => {
      mapElement.geom = parse(mapElement.geom);
      mapElement.type = this.geoType(mapElement.geom);
      mapElement.name = decodeURIComponent(mapElement.name);

      if (mapElement.mae_active === undefined) {
        mapElement.isactive = false;
      }
      else if (mapElement.mae_active === "true" || mapElement.mae_active === true) {
        mapElement.isactive = true;
      }
      else if (mapElement.mae_active === "false" || mapElement.mae_active === false) {
        mapElement.isactive = false;
      }

      if (
        mapElement.name === "" ||
        mapElement.name === null ||
        mapElement.name === undefined
      ) {
        mapElement.name = "Sans nom";
      }

      mapElement.color = decodeURIComponent(mapElement.color);

      this.addMapElement(mapElement);
      const id = ids.indexOf(mapElement.mae_id);
      if (id != -1) {
        ids = ids.filter((id) => id !== mapElement.mae_id);
      }
    });

    ids.forEach((id) => {
      this.dynamicmapelements.removeById(id);
    });
  }

  async addAwareElement(aware) {
    this.staticmapelements.addAware(aware);
  }
  /** --- */

  async addMapElement(mapElement) {
    if (mapElement.geom == null || mapElement.geom == undefined) {
      return;
    }

    if (mapElement.type == "Inconnu") {
      return;
    }

    let coords = undefined;

    if (mapElement.type === MapElementType.Point) {
      let lng = mapElement.geom.coordinates[0];
      let lat = mapElement.geom.coordinates[1];
      let hgt = 0;

      if (
        mapElement.geom.coordinates.length == 3 &&
        mapElement.geom.coordinates[2] !== 0
      ) {
        hgt = mapElement.geom.coordinates[2];
      }
      coords = new Cesium.Cartographic(lng, lat, hgt);
    }
    else if (mapElement.type === MapElementType.Polygone) {
      coords = [];
      mapElement.geom.coordinates[0].forEach((coord) => {
        let lng = coord[0];
        let lat = coord[1];
        let hgt = 0;
        if (coord.length == 3 && coord[2] !== 0) {
          hgt = coord[2];
        }
        if (coords.length < mapElement.geom.coordinates[0].length - 1) {
          //ne pas prendre le dernier point
          coords.push(new Cesium.Cartographic(lng, lat, hgt));
        }
      });
    }
    else if (mapElement.type === MapElementType.Ligne) {
      coords = [];
      mapElement.geom.coordinates.forEach((coord) => {
        let lng = coord[0];
        let lat = coord[1];
        let hgt = 0;
        if (coord.length == 3 && coord[2] !== 0) {
          hgt = coord[2];
        }
        coords.push(new Cesium.Cartographic(lng, lat, hgt));
      });
    }

    this.dynamicmapelements.addDynamic(
      coords,
      mapElement.type,
      mapElement.mae_id,
      mapElement.name,
      mapElement.isactive ,
      mapElement.color
    );
  }

  geoType(geo) {
    if (geo?.type === "Point") {
      return MapElementType.Point;
    } else if (geo?.type === "LineString") {
      return MapElementType.Ligne;
    } else if (geo?.type === "Polygon") {
      return MapElementType.Polygone;
    } else {
      return "Inconnu";
    }
  }
}
